import { render } from "./TemplateView.vue?vue&type=template&id=0b8f3f07&scoped=true"
import script from "./TemplateView.vue?vue&type=script&lang=js"
export * from "./TemplateView.vue?vue&type=script&lang=js"

import "./TemplateView.vue?vue&type=style&index=0&id=0b8f3f07&lang=scss&scoped=true"
import "./TemplateView.vue?vue&type=style&index=1&id=0b8f3f07&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8f3f07"]])

export default __exports__